import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import MenuToggle from './MenuToggle';
import Basket from './Basket';
import Logo from './Logo';
import MainNavigation from './MainNavigation';
import SpecialNavigation from './SpecialNavigation';
import CountryToggle from './CountryToggle';
import eventOptionsFactory from '../../../events/options-factory';
import FlashMessages from '../FlashMessages';
import TrustpilotWidget from '../TrustpilotWidget';
import './Header.scss';

const invalidatingEvents = ['scroll', 'wheel', 'resize'];

const noop = () => { };
const eventOptions = eventOptionsFactory({
  passive: true,
});

class Header extends React.Component {
  static propTypes = {
    navigation: PropTypes.shape({
      showLocaleCurrency: PropTypes.bool,
    }),
    model: PropTypes.object.isRequired,
    media: PropTypes.shape({
      desktopUp: PropTypes.bool.isRequired
    }).isRequired,
  };

  state = {
    isFixed: false,
  };

  constructor(props) {
    super(props);
    this.requestRedraw = this.requestRedraw.bind(this);
    this.redraw = this.redraw.bind(this);
    this.onRef = this.onRef.bind(this);
  }

  componentDidMount() {
    this._prevPosition = -1;
    this._prevOffset = -1;
    invalidatingEvents.forEach(eventName => {
      document.addEventListener(eventName, this.requestRedraw, eventOptions);
      window.addEventListener(eventName, this.requestRedraw, eventOptions);
    });
    this.requestRedraw();
  }

  componentWillUnmount() {
    invalidatingEvents.forEach(eventName => {
      document.removeEventListener(eventName, this.requestRedraw, eventOptions);
      window.removeEventListener(eventName, this.requestRedraw, eventOptions);
    });

    this._raf = false;
    cancelAnimationFrame(this._rafId);

    this._$header = null;
  }

  requestRedraw() {
    if (!this._raf) {
      this._raf = true;
      this._rafId = requestAnimationFrame(this.redraw);
    }
  }

  redraw() {
    if (!this._raf) {
      return;
    }
    this._raf = false;

    if (this._$header) {
      const currentOffset = this._$header.getBoundingClientRect().top;
      const currentPosition = window.pageYOffset;

      const positionChanged =
        this._prevPosition !== currentPosition ||
        this._prevOffset !== currentOffset;
      const isFixed = currentOffset <= 0;
      if (positionChanged && this.state.isFixed !== isFixed) {
        this.setState({ isFixed });
      }

      this._prevOffset = currentOffset;
      this._prevPosition = currentPosition;
    }
  }

  onRef($el) {
    if (this._$header !== $el) {
      this._$header = $el;
      this.requestRedraw();
    }
  }

  render() {
    const defaultBannerModel = this.props.model.prismicPromoBannerModel;
    const navigationModel = this.props.model.prismicNavigationModel;
    const countryModel = this.props.model.countryModel;
    return (
      <div className="header-wrap main-header" ref={this.onRef}>
        <header
          className={cx('header', { 'header-fixed': this.state.isFixed })}>
          <div className="container-guttered-on-desktop-up">
            <div className="header-inner">
              <div className="header-toggle-wrap">
                <MenuToggle />
              </div>
              <div className="header-logo-wrap">
                <Logo country={countryModel} onClickLink={noop} />
              </div>
              <div className="header-navigation">
                <div className="header-navigation-inner">
                  <div className="header-navigation-logo">
                    <Logo inNav country={countryModel} onClickLink={noop} />
                  </div>
                  <MainNavigation
                    country={countryModel}
                    navigation={navigationModel.mainNavigation}
                    onTrackLink={noop}
                  />
                  <SpecialNavigation
                    country={countryModel}
                    navigation={navigationModel.specialLinks}
                    onTrackLink={noop}
                  />
                  {this.props.media.desktopUp && navigationModel.showLocaleCurrency && <CountryToggle />}
                  {defaultBannerModel.trustpilotWidgetVisible &&
                    <TrustpilotWidget templateId="mini" className="header-trustpilot-mini" isComponent={false} />
                  }
                </div>
              </div>
              {!this.props.media.desktopUp && (
                <div className="header-basket-wrap">
                  {navigationModel.showLocaleCurrency && <CountryToggle />}
                  <Basket
                    country={countryModel}
                    cart={navigationModel.specialLinks}
                    isSolo
                  />
                </div>
              )}
            </div>
          </div>
          <FlashMessages />
        </header>
      </div>
    );
  }
}

export default Header;
